import axiosClient from "./axiosClient";

const dashboardMetricApi = {
  getMetrics: () => axiosClient.get("/dashboard/metrics"),
  getSessions: (params) => axiosClient.get("/dashboard/sessions", { params }),
  getTopPages: () => axiosClient.get("/dashboard/top-pages"),
};

export default dashboardMetricApi;